export default {
    methods: {
        setCanonicals(curPageNumber, curTotalPages) {
            // Self referencing
            let fullUrl = window.location.href;
            let link = document.createElement('link');
            link.href = fullUrl;
            link.rel = 'canonical';
            document.getElementsByTagName('head')[0].appendChild(link);

            // Prev and Next
            let pageNumber = curPageNumber;
            let totalPages = curTotalPages;
            if (pageNumber && totalPages) {
                pageNumber = parseInt(pageNumber);
                totalPages = parseInt(totalPages);

                // Prev
                if (pageNumber > 1 && pageNumber <= totalPages) {
                    let prevPageNumber = pageNumber - 1;
                    let fullUrl = window.location.origin + window.location.pathname + '#!/&page=' + prevPageNumber;
                    link = document.createElement('link');
                    link.href = fullUrl;
                    link.rel = 'prev';
                    document.getElementsByTagName('head')[0].appendChild(link);
                }

                //Next
                if (pageNumber < totalPages) {
                    let nextPageNumber = pageNumber + 1;
                    let fullUrl = window.location.origin + window.location.pathname + '#!/&page=' + nextPageNumber;
                    link = document.createElement('link');
                    link.href = fullUrl;
                    link.rel = 'next';
                    document.getElementsByTagName('head')[0].appendChild(link);
                }
            }
        }
    }
}